<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="rows"
		:addRowData="addRowData"
		selection
		creatable
		editable
		:saveFunc="saveFunc"
		@changedPage="changedPage"
		@row-click="rowClick"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.row.permGrpCd === '44'">
				<template v-if="slotProps.column.property === 'useYn'">
					<el-input
						:value="slotProps.row[slotProps.column.property]"
						@input="
							value => {
								slotProps.row[slotProps.column.property] = value;
							}
						"
					/>
				</template>
			</template>
			<template v-else>
				<el-select
					v-model="slotProps.row[slotProps.column.property]"
					filterable
					@change="changedRow(slotProps.row, slotProps.column.property)"
				>
					<el-option v-for="option in gridUseYnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
				</el-select>
			</template>

			<!-- <template v-if="slotProps.column.property === 'permGrpCd'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input v-model="slotProps.row[slotProps.column.property]" maxlength="5" />
				</template>
				<template v-else>
					<span @click="() => onClick(slotProps.row.permGrpCd)" :style="{ color: 'orange', fontWeight: 'bold', cursor: 'pointer' }">
						{{ slotProps.row.permGrpCd }}
					</span>
				</template>
			</template> -->
		</template>

		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CD')" line icon="trash" color="error" :onClick="deleteAction">
				{{ getMessage_('MWCC000328') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			addRowData: {
				rowType: 'add',
				permGrpCd: null,
				userGrpName: null,
				useYn: 'Y',
				useYnBk: 'Y'
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('MWCC000104'),
					prop: 'permGrpCd',
					minWidth: '180px'
					// custom: true
				},
				{
					label: this.getMessage_('MWCC000105'),
					prop: 'userGrpName',
					minWidth: '180px',
					type: 'input',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('MWCC000106'),
					prop: 'useYn',
					minWidth: '120px',
					custom: true
					// form: {
					// 	type: 'select',
					// 	options: this.gridUseYnList
					// }
				},
				{
					label: this.getMessage_('MWCC000004'),
					prop: 'regDt',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('MWCC000005'),
					prop: 'regId',
					minWidth: '150px',
					sortable: false
				}
			];
		},
		schema() {
			return yup.array().of(
				yup.object().shape({
					permGrpCd: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000104')])) //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		addAction() {
			this.rows.unshift(this.addRowData);
			this.$refs.dataTable.getTable().toggleRowSelection(this.addRowData);
		},
		saveAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			if (!selected.length) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000108'),
				buttons: [{ title: 'Ok', clickFn: () => this.delete(selected) }]
			});
		},
		delete() {
			let sendData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				data: []
			};

			const selected = this.$refs.dataTable.getSelectedRows();

			selected.forEach(row => {
				if (row.permGrpCd == null || row.permGrpCd.trim().length < 1) {
					let showMsg1 = this.getMessage_('MWCC000104');
					this.$sf_showMessage({
						title: this.getMessage_('MWCC000415'), // 입력 정보를 확인해주세요.
						message: `<b>${showMsg1}</b> <br/> 필수 입력.`
					});
					return;
				}

				let pushSet = {
					permGrpCd: row.permGrpCd,
					userGrpName: row.userGrpName ? row.userGrpName : '',
					useYn: 'N',
					regId: 'ADMIN',
					chgId: 'ADMIN',
					state: row.tableState
				};
				sendData.data.push(pushSet);
			});

			if (sendData.data.length) {
				this.$sf_toggleLoading(true);
				this.setGroups_(sendData)
					.then(header => {
						if (header.code === 0 || header.code === 3) {
							this.$sf_toast({
								type: header.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(header.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message || e
						});
						return e;
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		save(saveRows) {
			try {
				// 유효성 검사
				this.schema.validateSync(saveRows);

				let sendData = {
					status: 1,
					plantCd: this.searchParams.plantCd,
					data: []
				};

				const selected = this.$refs.dataTable.getSelectedRows();

				selected.forEach(row => {
					// console.log('2');
					let pushSet = {
						permGrpCd: row.permGrpCd,
						userGrpName: row.userGrpName || '',
						useYn: row.useYn || 'Y',
						// regId: this.user.userId,
						// chgId: this.user.userId,
						state: row.tableState
					};
					sendData.data.push(pushSet);
				});

				if (sendData.data.length) {
					// console.log('3');
					this.$sf_toggleLoading(true);
					this.setGroups_(sendData)
						.then(header => {
							if (header.code === 0 || header.code === 3) {
								this.$sf_toast({
									type: header.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(header.messageCd)
								});
							}
							this.resetTable();
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		saveFunc(saveRows) {
			//console.log(saveRows);
		},
		saveClick() {
			if (this.$refs.dataTable.multipleSelection.length < 1) {
				// title MWCC000110
				this.$sf_showMessage({ title: this.getMessage_('MWCC000110'), message: this.getMessage_('MWCC000434') });
				// message 저장 할 데이터를 선택해주세요.
				return;
			}
			this.$sf_showMessage({
				type: 'confirm',
				message: this.getMessage_('MWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		rowClick(row, column, devent) {
			this.setState_({ key: 'selectedRow', value: row });
		},
		async onClick(mainKey) {
			let item = {
				name: mainKey + ' 상세화면', //탭에 표시하기 위한 이름, 다국어: 사이트맵
				component: () => import('@qms/Blank/Blank.vue').catch(() => {}),
				// scrId: 'OS10001079',
				// scrId: 'OS10001073Tab',
				scrId: this.scrId + '_Tab',
				msgKey: 'MWCC000438'
			};
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, {
				scrId: item.scrId,
				scrTitle: item.name,
				//oriScrId: 'OS10001073',
				oriScrId: this.scrId,
				blankScrId: item.scrId,
				mainKey,
				// 'src/views 이후의 경로 기재
				contentComponent: `/qms/FreeForm/Content/Table/TableViewTwo.vue`
			});
		}
	}
};
</script>

<style></style>
